import React, { useState, forwardRef, useImperativeHandle } from 'react';
import '../../styles/projects/projects.css';
import { ReactComponent as DataIcon } from '../../assets/svg/data-svg.svg';


const WP3 = forwardRef((props, ref) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const sectionRef = React.useRef(null);

	const toggleExpand = () => {
		setIsExpanded(!isExpanded);
	};

	useImperativeHandle(ref, () => ({
		expandSection() {
			if (sectionRef.current) {
				const yOffset = -100; 
				const y = sectionRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
				window.scrollTo({ top: y, behavior: 'smooth' });
				setTimeout(() => {
					setIsExpanded(true);
				}, 400); 
			}
		},
	}));

	const leaders = [
		{ name: 'David Tamborero (KI)', link: 'https://ki.se/en/people/david-tamborero' },
		{ name: 'Filip Årman (LU)', link: 'https://www.lu.se/lucat/user/033a34ec76f359e3589f81316d1eeefe' },
		{ name: 'Johannes Fuchs (GU)', link: 'https://www.gu.se/om-universitetet/hitta-person/johannesfuchs' },
		{ name: 'Jorrit Boekel (KI)', link: 'https://ki.se/en/people/jorrit-boekel' },
		{ name: 'Mikael Björnstedt (Karolinska Univ. Sjukhuset)', link: 'https://ki.se/personer/mikael-bjornstedt' },
		{ name: 'Edvard Abel (Salgrenska)', link: null },
		{ name: 'Maria Planck (Skånes Univ. Sjukhus)', link: 'https://www.lu.se/lucat/user/849eb7fe92c1ca1ad15ecdc71512e6ca' },
	];

	const [lead, ...participants] = leaders;
	const renderPerson = (person, key) =>
		person.link ? (
			<a key={key} href={person.link} target="_blank" rel="noopener noreferrer">
				{person.name}
			</a>
		) : (
			<span key={key}>{person.name}</span>
		);

	return (
		<section className="WPinfo" ref={sectionRef}>
			<span className='wpinfo-icon'>
				<DataIcon />
			</span>
			<span className="WPinfo-body">
				<h2>Work package 3: Clinical proteomics data sharing and reporting platform</h2>
				<p>
					<strong>Led by:</strong>{' '}
					{renderPerson(lead, 'lead')}
				</p>

				{participants.length > 0 && (
					<p>
						<strong>Participants:</strong>{' '}
						{participants.map((p, i) => (
						<React.Fragment key={i}>
							{renderPerson(p, i)}
							{i < participants.length - 1 && ', '}
						</React.Fragment>
						))}
						.
					</p>
				)}
				<div className={`expandable-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
					WP3 is dedicated to building a secure and harmonized platform for managing clinical proteomics data across multiple institutions. By establishing shared agreements and collaborating with national data science infrastructures, the team ensures that sensitive information is stored safely and processed consistently. A standardized analysis pipeline will be developed to link raw data directly to a central repository, enabling reproducible and transparent workflows. Importantly, this effort also connects proteomics insights to other molecular data streams within the Molecular Tumor Board Portal, supporting clinical decision-making. A proof-of-concept study will demonstrate how proteomics findings can be reported in a clinically relevant way, paving the path toward national integration of proteomics into precision medicine. 
				</div>
				<button className="read-more-btn" onClick={toggleExpand}>
					{isExpanded ? 'Show Less' : 'Read More'}
				</button>
			</span>
		</section>
	);
});

export default WP3;
